import React from 'react';
import { Box, SxProps, Theme, ToggleButton } from '@mui/material';

export interface MemberStateToggle {
  id: string;
  label: string;
  selected: boolean;
  onToggle: () => void;
}

export const MemberStateToggles: React.FC<{ toggles: MemberStateToggle[]; sx?: SxProps<Theme> }> = ({ toggles, sx }) => {
  if (toggles.length === 0) return null;
  return (
    <Box sx={[{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }, ...(Array.isArray(sx) ? sx : [sx])]}>
      {toggles.map((toggle) => (
        <ToggleButton
          key={toggle.id}
          size="small"
          value={toggle.id}
          selected={toggle.selected}
          onChange={toggle.onToggle}
        >
          {toggle.label}
        </ToggleButton>
      ))}
    </Box>
  );
};
